export const ONE_MODELS = 'ONE_MODELS';
